import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import { useInformationalModal } from '../context/InformationalModalContext';

const InformationalModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useInformationalModal();

  const isButtonEnabled = !!data.date;

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-lg btn-primary"
        onClick={actions.handleSaveInformational}
        disabled={!isButtonEnabled}
      >
        {t('SaveOperation')}
      </button>
    </Modal.Footer>
  );
};

export default InformationalModalFooter;
